/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore from 'swiper'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import 'swiper/css/bundle'
import { Header2, Header3 } from '../styles/Components'
import { gsColors } from '../styles/Variables'
import styled from '@emotion/styled'
import { mq } from '../helpers'

const ReviewScroll = ({ reviews }) => {
  SwiperCore.use([Pagination, Autoplay, Navigation])

  return (
    <ReviewsWrapper>
      <Header2 color={gsColors.salmon} margin="0 0 32px">
        The reviews are in
      </Header2>
      <div className="swiper-container-container">
        <Swiper
          modules={[Navigation, Autoplay]}
          slidesPerView={1}
          autoplay={{ delay: 3000, disableOnInteraction: true }}
          navigation={{
            nextEl: '.custom-next-button',
            prevEl: '.custom-prev-button',
          }}
          className="swiper-container"
        >
          {reviews.map((r, i) => (
            <SwiperSlide key={i}>
              <div className="rating">
                <div className="star-container">
                  {new Array(5).fill('').map((_, i) => (
                    <img
                      key={i}
                      src="/home/star.svg"
                      width="24"
                      height="24"
                      alt="star"
                    />
                  ))}
                </div>
                <Header3 color="#fff" align="center" margin="0 0 16px 0">
                  {r.quote}
                </Header3>
                <Header3 color="#fff" align="center">
                  - {r.name}
                </Header3>
              </div>
            </SwiperSlide>
          ))}
          <button className="custom-prev-button" />
          <button className="custom-next-button" />
        </Swiper>
      </div>
    </ReviewsWrapper>
  )
}

const ReviewsWrapper = styled.section`
  box-sizing: border-box;
  width: 100%;
  max-width: 1600px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
  background-color: ${gsColors.cobalt};

  ${mq('max', '768px')} {
    padding: 60px 16px;
  }

  .swiper-container-container {
    width: 610px;

    ${mq('max', '768px')} {
      width: 100%;
    }

    .swiper-container {
      position: relative;
      padding-bottom: 40px;
      display: flex;
      justify-content: center;
      align-items: center;

      .custom-next-button {
        background-image: url('/images/arrow-right.png');
        background-color: transparent;
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center;
        border: none;
        height: 32px;
        width: 32px;
        position: absolute;
        bottom: 0;
        right: 40%;
        z-index: 999;
        cursor: pointer;
      }
      
      .custom-prev-button {
        background-image: url('/images/arrow-left.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center;
        background-color: transparent;
        border: none;
        height: 32px;
        width: 32px;
        position: absolute;
        bottom: 0;
        left: 40%;
        z-index: 999;
        cursor: pointer;
      }
    }


    .rating {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      ${mq('max', '768px')} {
        max-width: 90%;
        margin: 0 auto;
      }
  
      .star-container {
        display: flex;
        flex-direction: row;
        gap: 3px;
        margin-bottom: 12px;
      }
    }
  }
`

export default ReviewScroll
